import { useCallback, useMemo, useState, type ReactNode } from 'react';
import { detectInitialLocale, persistLocale } from '@/i18n/detect';
import { catalogs } from '@/i18n/messages';
import { LocaleContext } from '@/i18n/LocaleContext';
import { createTranslator } from '@/i18n/translate';
import type { Locale } from '@/i18n/types';

export function LocaleProvider({ children }: { children: ReactNode }) {
  const [locale, setLocaleState] = useState<Locale>(() => {
    const initial = detectInitialLocale();
    persistLocale(initial);
    return initial;
  });

  const setLocale = useCallback((next: Locale) => {
    setLocaleState(next);
    persistLocale(next);
  }, []);

  const t = useMemo(() => createTranslator(catalogs[locale], catalogs.en), [locale]);

  const value = useMemo(() => ({ locale, setLocale, t }), [locale, setLocale, t]);

  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
}
